export default __webpack_public_path__ + "static/media/ocpb-logo.46da9e77.svg";